import { Component, OnInit } from '@angular/core';
import {Organisation} from '../../../../model/organisation/Organisation';
import {AuthUser} from '../../../../model/user/authUser';
import {AuthUserService} from '../../../../service/interne/user/AuthUserService';
import {FormeJuridique} from '../../../../model/organisation/FormeJuridique';
import {FormeJuridiqueService} from '../../../../service/interne/organisation/FormeJuridiqueService';
import {Genre} from '../../../../model/contact/Genre';
import {GenreService} from '../../../../service/interne/genre/GenreService';
import {CodeApe} from '../../../../model/organisation/CodeApe';
import {CodeApeService} from '../../../../service/interne/organisation/CodeApeService';
import {FormatIntranetShareService} from '../../../../service/partage/prototype/FormatIntranetShareService';
import {OrganisationService} from '../../../../service/interne/organisation/OrganisationService';
import {Pays} from '../../../../model/information/Pays';
import {PaysService} from '../../../../service/interne/contact/PaysService';
import {ListeOrganisation} from '../../../../model/liste/ListeOrganisation';
import {ListeOrganisationService} from '../../../../service/interne/organisation/ListeOrganisationService';
import {OpenWithPostShareService} from '../../../../service/partage/utilitaire/OpenWithPostShareService';
import {AuthShareService} from '../../../../service/partage/AuthShareService';
import {NgxSpinnerService} from 'ngx-spinner';
import {ListeParution} from '../../../../model/liste/ListeParution';
import {DialogueShareService} from '../../../../service/partage/utilitaire/DialogueShareService';
import {Environement} from '../../../../environement/environement';
import {ListeParutionParution} from '../../../../model/liste/ListeParutionParution';
import {ListeOrganisationOrganisation} from '../../../../model/liste/ListeOrganisationOrganisation';

@Component({
  selector: 'app-escal-organisation-recherche',
  templateUrl: './escal-organisation-recherche.component.html',
  styleUrls: ['./escal-organisation-recherche.component.scss'],
  providers: [AuthUserService, FormeJuridiqueService, GenreService, CodeApeService, OrganisationService, PaysService, ListeOrganisationService]
})
export class EscalOrganisationRechercheComponent implements OnInit {

  rechercheEnCours: boolean;
  affiche: boolean;
  afficheCateg: boolean;
  rechercheEncoursDirigeant = false;
  rechercheEncoursCateg = false;
  creeChoisi: string;
  nom: string;
  siren: string;
  capital: string;
  effectif: string;
  implantation: string;
  premierTel: string;
  deuxiemeTel: string;
  email: string;
  premierURL: string;
  deuxiemeURL: string;
  rue: string;
  complements: string;
  codePostal: string;
  boitePostale: string;
  ville: string;
  champRechercheDirigeant: string;
  champRechercheCateg: string;
  formeId: number;
  genreId: number;
  codeId: number;
  dirigeantId: number;
  categId: number;
  paysId: number;
  jours: number;
  suiviPar: number;
  total: number;
  maxPage: number;
  societesRecherchesAvancees: Array<Organisation>;
  societes: Array<Organisation>;
  formes: Array<FormeJuridique>;
  genres: Array<Genre>;
  codes: Array<CodeApe>;
  pays: Array<Pays>;
  users: Array<AuthUser> = [];
  dirigeantsRecherche: Array<any> = [];
  categoriesRecherche: Array<any> = [];
  curentPage = 1;
  headerContent: Array<any> = [];
  exportEnCours: boolean;
  associationEnCours: boolean;
  associationFait: boolean;
  listeOrganisationId: number;
  listesOrganisation: Array<ListeOrganisation>;
  toggleActive = false;
  idcheck: boolean;
  nomcheck: boolean;
  dirigeantcheck: boolean;
  datecheck: boolean;
  codecheck: boolean;
  sirencheck: boolean;
  formecheck: boolean;
  capitalcheck: boolean;
  effectifcheck: boolean;
  implantationcheck: boolean;
  genrecheck: boolean;
  categcheck: boolean;
  commentairecheck: boolean;
  premierTelcheck: boolean;
  deuxiemeTelcheck: boolean;
  emailcheck: boolean;
  ruecheck: boolean;
  complementcheck: boolean;
  bpostalcheck: boolean;
  cpostalcheck: boolean;
  villecheck: boolean;
  payscheck: boolean;
  premierURLcheck: boolean;
  deuxiemeURLcheck: boolean;
  constructor(private authUserService: AuthUserService, private formeJuridiqueService: FormeJuridiqueService,
              private genreService: GenreService, private codeApeService: CodeApeService,
              public formatIntranetShareService: FormatIntranetShareService, private organisationService: OrganisationService,
              private paysService: PaysService, private listeOrganisationService: ListeOrganisationService,
              private openWithPostService: OpenWithPostShareService, private authShareService: AuthShareService,
              private spinner: NgxSpinnerService, private dialogueShareService: DialogueShareService) { }

  ngOnInit() {
    this.headerContent.push('isOrganisation');
    this.headerContent.push('Nom');
    this.headerContent.push('Genre');
    this.headerContent.push('Forme');
    this.headerContent.push('Catégorie');

    this.jours = 0;
    this.suiviPar = 0;
    this.formeId = 0;
    this.genreId = 0;
    this.codeId = 0;
    this.dirigeantId = 0;
    this.categId = 0;
    this.paysId = 0;
    this.creeChoisi = '';
    this.nom = '';
    this.siren = '';
    this.capital = '';
    this.effectif = '';
    this.implantation = '';
    this.premierTel = '';
    this.deuxiemeTel = '';
    this.email = '';
    this.premierURL = '';
    this.deuxiemeURL = '';
    this.rue = '';
    this.complements = '';
    this.codePostal = '';
    this.boitePostale = '';
    this.ville = '';
    this.champRechercheDirigeant = '';
    this.champRechercheCateg = '';
    this.rechercheEnCours = false;
    this.exportEnCours = false;
    this.associationEnCours = false;
    this.associationFait = false;
    this.affiche = false;
    this.afficheCateg = false;
    this.societesRecherchesAvancees = [];
    this.societes = [];
    this.listeOrganisationId = 0;
    this.listesOrganisation = [];
    this.idcheck = true;
    this.nomcheck = true;
    this.dirigeantcheck = true;
    this.datecheck = false;
    this.codecheck = false;
    this.sirencheck = false;
    this.formecheck = false;
    this.capitalcheck = false;
    this.effectifcheck = false;
    this.implantationcheck = false;
    this.genrecheck = false;
    this.categcheck = false;
    this.commentairecheck = false;
    this.premierTelcheck = true;
    this.deuxiemeTelcheck = false;
    this.emailcheck = true;
    this.ruecheck = false;
    this.complementcheck = false;
    this.bpostalcheck = false;
    this.cpostalcheck = false;
    this.villecheck = true;
    this.payscheck = false;
    this.premierURLcheck = false;
    this.deuxiemeURLcheck = false;
    this.formeJuridiqueService.getFormesJuridiques().then(formesJ => {
      this.formes = formesJ['hydra:member'] as Array<FormeJuridique>;
    });
    this.genreService.getGenres().then(genres => {
      this.genres = genres['hydra:member'] as Array<Genre>;
    });
    this.codeApeService.getCodes().then(codes => {
      this.codes = codes['hydra:member'] as Array<CodeApe>;
    });
    this.paysService.getAllPays().then(pays => {
      this.pays = pays['hydra:member'] as Array<Pays>;
    });
    this.authUserService.getUsersList(1).then((usersRetour) => {
      this.users = usersRetour['hydra:member'] as Array<AuthUser>;
    });
  }

  rechercheDirigeant() {
    this.affiche = true;
    if (this.champRechercheDirigeant.length > 2 && !this.rechercheEncoursDirigeant) {
      this.rechercheEncoursDirigeant = true;
      this.champRechercheDirigeant = this.champRechercheDirigeant.replace(' ', '.');
      this.organisationService.getDirigeantRecherche(this.champRechercheDirigeant).then((retour) => {
        this.dirigeantsRecherche = retour;
        this.dirigeantsRecherche.forEach(dirigeant => {
          if (dirigeant.nomPrenom != '' && dirigeant.nomPrenom != null) {
            dirigeant.nomPrenom = dirigeant.nomPrenom.replace('&amp;', '&');
            dirigeant.nomPrenom = dirigeant.nomPrenom.replace('&#039;', '’');
            dirigeant.nomPrenom = dirigeant.nomPrenom.replace('L&#039;', 'L’');
          }
        });
        this.champRechercheDirigeant = this.champRechercheDirigeant.replace('.', ' ');
      });
      this.rechercheEncoursDirigeant = false;
    }
  }

  rechercheCategories() {
    this.afficheCateg = true;
    if (this.champRechercheCateg.length > 2 && !this.rechercheEncoursCateg) {
      this.rechercheEncoursCateg = true;
      this.champRechercheCateg = this.champRechercheCateg.replace(' ', '.');
      this.organisationService.getCategoriesRecherche(this.champRechercheCateg).then((retour) => {
        this.categoriesRecherche = retour;
        this.categoriesRecherche.forEach(categorie => {
          if (categorie.nom != '' && categorie.nom != null) {
            categorie.nom = categorie.nom.replace('&amp;', '&');
            categorie.nom = categorie.nom.replace('&#039;', '’');
            categorie.nom = categorie.nom.replace('L&#039;', 'L’');
          }
        });
        this.champRechercheCateg = this.champRechercheCateg.replace('.', ' ');
      });
      this.rechercheEncoursCateg = false;
    }
  }

  rechercherSocietes() {
    this.organisationService.getSocietesRechercheAvancee(this.nom, this.siren, this.capital, this.effectif,
      this.implantation, this.formeId, this.genreId, this.suiviPar, this.codeId, this.dirigeantId, this.categId,
      this.premierTel, this.deuxiemeTel, this.email, this.premierURL, this.deuxiemeURL, this.rue, this.complements,
      this.codePostal, this.boitePostale, this.paysId, this.creeChoisi, this.jours, this.curentPage).then((retour) => {
      this.societesRecherchesAvancees = retour['hydra:member'] as Array<Organisation>;
      this.total = retour['hydra:totalItems'];
      this.getMaxPage(retour['hydra:totalItems']);
      this.rechercheEnCours = true;
    });
  }

  getMaxPage(nbElement) {
    this.maxPage = Math.trunc(nbElement / 10);
    if (nbElement % 10 !== 0) {
      this.maxPage = this.maxPage + 1;
    }
  }

  changePage(page) {
    this.curentPage = page;
    this.rechercherSocietes();
  }

  reprendreRecherche() {
    this.rechercheEnCours = false;
    this.curentPage = 1;
  }

  retourResultats() {
    this.rechercheEnCours = true;
    this.exportEnCours = false;
    this.associationEnCours = false;
    this.associationFait = false;
  }

  associerListe() {
    this.listesOrganisation = [];
    this.associationEnCours = true;
    this.listeOrganisationService.getAllListesOrganisationsPar().then(listesOrganisation => {
      this.listesOrganisation = listesOrganisation['hydra:member'] as Array<ListeOrganisation>;
    });
  }

  associerOrganisations() {
    if (this.listeOrganisationId != 0) {
      this.spinner.show();
      // get all societes, pas que celles par pagination
      this.organisationService.getSocietesRechercheAvanceeAll(this.nom, this.siren, this.capital, this.effectif,
        this.implantation, this.formeId, this.genreId, this.suiviPar, this.codeId, this.dirigeantId, this.categId,
        this.premierTel, this.deuxiemeTel, this.email, this.premierURL, this.deuxiemeURL, this.rue, this.complements,
        this.codePostal, this.boitePostale, this.paysId, this.creeChoisi, this.jours).then(async (retour) => {
        this.societes = retour['hydra:member'] as Array<Organisation>;
        for (const societe of this.societes) {
          // associer sur escalnet
          await this.listeOrganisationService.getOneAssoOrganisationListe(this.listeOrganisationId, societe.id).then((asso) => {
            if (asso['hydra:member'][0] == undefined) {
              this.listeOrganisationService.addOrganisationListe(this.listeOrganisationId, societe.id).then();
            }
          });
          // associer sur intranet
          this.listeOrganisationService.getListeOrganisationDetails(this.listeOrganisationId)
            .then((listeOrganisation) => {
              const liste = listeOrganisation as ListeOrganisation;
              this.listeOrganisationService.associerListeOrganisation(liste.ancienId, societe.ancienId).then();
            });
        }
        this.spinner.hide();
        this.associationEnCours = false;
        this.associationFait = true;
      });
    } else {
      this.dialogueShareService.addDialogue('La liste est obligatoire');
    }
  }

  modifierActive() {
    if (this.toggleActive === false) {
      this.idcheck = false;
      this.nomcheck = false;
      this.dirigeantcheck = false;
      this.datecheck = false;
      this.codecheck = false;
      this.sirencheck = false;
      this.formecheck = false;
      this.capitalcheck = false;
      this.effectifcheck = false;
      this.implantationcheck = false;
      this.genrecheck = false;
      this.categcheck = false;
      this.commentairecheck = false;
      this.premierTelcheck = false;
      this.deuxiemeTelcheck = false;
      this.emailcheck = false;
      this.ruecheck = false;
      this.complementcheck = false;
      this.bpostalcheck = false;
      this.cpostalcheck = false;
      this.villecheck = false;
      this.payscheck = false;
      this.premierURLcheck = false;
      this.deuxiemeURLcheck = false;
    } else {
      this.idcheck = true;
      this.nomcheck = true;
      this.dirigeantcheck = true;
      this.datecheck = true;
      this.codecheck = true;
      this.sirencheck = true;
      this.formecheck = true;
      this.capitalcheck = true;
      this.effectifcheck = true;
      this.implantationcheck = true;
      this.genrecheck = true;
      this.categcheck = true;
      this.commentairecheck = true;
      this.premierTelcheck = true;
      this.deuxiemeTelcheck = true;
      this.emailcheck = true;
      this.ruecheck = true;
      this.complementcheck = true;
      this.bpostalcheck = true;
      this.cpostalcheck = true;
      this.villecheck = true;
      this.payscheck = true;
      this.premierURLcheck = true;
      this.deuxiemeURLcheck = true;
    }
  }

  exportChoix() {
    this.exportEnCours = true;
  }

  exporterListeOrganisation() {
    this.spinner.show();
    let url: string;
    const listeOrganisation = new ListeOrganisation(0, 'Liste temporaire export', '', new Date(), null,
      this.authShareService.authUser, [], 0);
    this.organisationService.getSocietesRechercheAvanceeAll(this.nom, this.siren, this.capital, this.effectif,
      this.implantation, this.formeId, this.genreId, this.suiviPar, this.codeId, this.dirigeantId, this.categId,
      this.premierTel, this.deuxiemeTel, this.email, this.premierURL, this.deuxiemeURL, this.rue, this.complements,
      this.codePostal, this.boitePostale, this.paysId, this.creeChoisi, this.jours).then(async (retour) => {
      this.societes = retour['hydra:member'] as Array<Organisation>;
      // créer liste temporaire
      this.listeOrganisationService.addListeOrganisation(listeOrganisation).then(async liste => {
        const listeId = liste.id;
        if (this.societes.length > 0) {
          // on ajoute les societes à la liste temporaire
          for (const societe of this.societes) {
            await this.listeOrganisationService.addOrganisationListe(listeId, societe.id);
          }
          // exporter les societes de la liste temporaire
          this.listeOrganisationService.exporterListeOrganisation(listeId, this.idcheck, this.nomcheck, this.dirigeantcheck,
            this.datecheck, this.codecheck, this.sirencheck, this.formecheck, this.capitalcheck, this.effectifcheck,
            this.implantationcheck, this.genrecheck, this.categcheck, this.commentairecheck, this.premierTelcheck, this.deuxiemeTelcheck,
            this.emailcheck, this.ruecheck, this.complementcheck, this.bpostalcheck, this.cpostalcheck, this.villecheck, this.payscheck,
            this.premierURLcheck, this.deuxiemeURLcheck).then(async () => {
            url = Environement.BASE_API_URL + '/excelStat/' + listeId + 'exportListeSociete.xlsx';
            this.openWithPostService.openWindows(url);
            // pour chaque societe associée on supprime l'asso
            let assosListeOrganisation = [];
            await this.listeOrganisationService.getListeOrganisationAllAssos(listeId).then(async (assos) => {
              assosListeOrganisation = assos['hydra:member'] as Array<ListeOrganisationOrganisation>;
              if (assosListeOrganisation != null) {
                for (const asso of assosListeOrganisation) {
                  await this.listeOrganisationService.supprimerAssoListeOrganisation(asso.id).then();
                }
                // on supprime la liste temporaire
                await this.listeOrganisationService.supprimerListeOrganisation(listeId).then();
                this.spinner.hide();
              }
            });
          });
        }
      });
    });
  }

}
